import axiosInstance from "shared/axios";

const SUBUSER_URI = {
  listing: "/api/v1/subuser/payments",
};

export const subuserPaymentListing = (select, serach, subUserRefNo, offset) => {
  let url = `${select}=${serach}&offset=${offset}`;
  if (subUserRefNo) {
    url = url + `&search_by_subuser=${subUserRefNo}`;
  }
  return axiosInstance.get(`${SUBUSER_URI.listing}?${url}`);
};

export const subuserPaymentDetails = (ref_no) => {
  return axiosInstance.get(`${SUBUSER_URI.listing}/${ref_no}`);
};

export const captureRazorpayPayment = (payment_ref_no) => {
  return axiosInstance.post(
    `${SUBUSER_URI.listing}/${payment_ref_no}/capture-payment`
  );
};

export const verifySubUserPayment = (ref,param) => {
  return axiosInstance.post(`${SUBUSER_URI.listing}/${ref}/verify`,param);
};
